import { useRef, useEffect, useState, useContext } from "react";
import Calendar from "@toast-ui/react-calendar";
import { CalendarView } from "src/utils/constants";
import { useGetMeetingsLazyQuery } from "src/generated/graphql";
import { AppContext } from "src/api/AppContext";

export default function useMeetingCalendar() {
  // Calendar Date functions
  const todayStart = new Date();
  const todayEnd = new Date();
  todayStart.setHours(0, 0, 0, 0);
  todayEnd.setHours(23, 59, 59, 999);
  let calendarRef = useRef<Calendar>(null);
  const { currentLocation } = useContext(AppContext);
  const calendarInstance = calendarRef.current?.getInstance();
  const [viewCalendar, setViewCalendar] = useState(CalendarView.Month);
  const [isListView, setisListView] = useState(false);
  const [dateRange, setDateRange] = useState<[Date, Date]>([
    todayStart,
    todayEnd,
  ]);

  useEffect(() => {
    calendarInstance && getDateRange();
  }, [calendarInstance, viewCalendar, currentLocation]);

  useEffect(() => {
    refetch();
  }, [dateRange]);

  const [getMeetings, { data: meetingDetails, loading: meetingLoading }] =
    useGetMeetingsLazyQuery({
      fetchPolicy: "network-only",
    });

  const moveToday = () => {
    calendarInstance?.setDate(new Date());
    setDateRange([todayStart, todayEnd]);
  };

  const handleNext = () => {
    calendarInstance?.next();
    getDateRange();
  };

  const handlePrev = () => {
    calendarInstance?.prev();
    getDateRange();
  };

  const getDateRange = () => {
    if (calendarInstance) {
      setDateRange([
        calendarInstance.getDateRangeStart().toDate(),
        calendarInstance.getDateRangeEnd().toDate(),
      ]);
      refetch();
    }
  };

  const refetch = () => {
    if (calendarInstance && currentLocation) {
      getMeetings({
        variables: {
          locationId: currentLocation.id,
          startAt: calendarInstance.getDateRangeStart().toDate().toUTCString(),
          endAt: calendarInstance.getDateRangeEnd().toDate().toUTCString(),
        },
      });
    }
  };

  return {
    handlePrev,
    handleNext,
    moveToday,
    dateRange,
    viewCalendar,
    setViewCalendar,
    isListView,
    setisListView,
    calendarRef,
    calendarInstance,
    meetingDetails,
    meetingLoading,
    refetch,
  };
}
